module.exports = __webpack_public_path__ + "img/Time-zone.a52986fe.svg";